import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import {PanelFooterButtons} from './PanelFooterButtons';
import {getLastLevelFields} from '../../Common/actions/Screen';
import {selectScrollField, isMovementsPanelShown} from '../actions/Screen';
import {texts, getLocalizedText} from '../../../../constants/TextConst';
import Search from '../../../../components/Common/Search';
import SystemReportMenu from './SystemReportMenu';
import List from '../../../../components/Common/List';
import {CollapsibleField} from '../../../../components/Common/Collapsible';
import SystemReportField from './SystemReportField';
import Movements from '../../../../components/Common/Movements';

@observer
export default class SystemReport extends Component<any, any> {
    constructor(props) {
        super(props);

        this.selectSearchOption = this.selectSearchOption.bind(this);
        this.renderItem = this.renderItem.bind(this);
    }

    selectSearchOption(field) {
        selectScrollField(field);
    }

    renderMovementsPanel() {
        const {screen} = this.props;
        return (
            <div>
                <Search
                    options={getLastLevelFields(screen)}
                    placeholder={
                        getLocalizedText(texts.search) +
                        ' ' +
                        (screen.entityName ? screen.entityName : '')
                    }
                    onOptionSelect={this.selectSearchOption}
                />
                {isMovementsPanelShown(screen) && <Movements field={screen.selected} />}
            </div>
        );
    }

    renderActionsMenu() {
        const {screen, open, funcs, fontFamilies} = this.props;
        const {active} = screen;
        const actionsOpen = open && active && !active.isChanging;
        return (
            <SystemReportMenu
                open={actionsOpen}
                field={active}
                funcs={funcs}
                fontFamilies={fontFamilies}
            />
        );
    }

    renderItem({item}) {
        return (
            <CollapsibleField
                field={item}
                renderParent={SystemReportField}
                renderChild={SystemReportField}
            />
        );
    }

    renderList() {
        const {screen} = this.props;
        const movementsPanelShown = isMovementsPanelShown(screen);
        return (
            <div className={`list long ${!movementsPanelShown && 'longer longest'}`}>
                <div className="line" />
                <List
                    data={screen.collection.fields}
                    keyExtractor={field => field.name}
                    renderItem={this.renderItem}
                />
                {this.renderActionsMenu()}
            </div>
        );
    }

    render() {
        const {closePanel, screensStore} = this.props;
        return (
            <div className="screen">
                <div className="content-wrapper">
                    <div className="content">
                        {this.renderMovementsPanel()}
                        {this.renderList()}
                    </div>
                </div>
                <PanelFooterButtons closePanel={closePanel} screensStore={screensStore} />
            </div>
        );
    }
}
